<ion-content>
  <!-- Breadcrumb -->
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a [routerLink]="['/home']" routerDirection="root">Home</a>
    </li>
  </ol>
  <app-loading *ngIf="gettingAllAuthenticatedUserJobs"></app-loading>

  <div *ngIf="!gettingAllAuthenticatedUserJobs" class="animated fadeIn text-right top-page-nav">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-secondary" [ngClass]="{'active btn-secondary': filter == 'all'}" (click)="switchFilter('all')">All</button>
      <button type="button" class="btn btn-outline-secondary" [ngClass]="{'active btn-secondary': filter == 'open'}" (click)="switchFilter('open')">Open</button>
      <button type="button" class="btn btn-outline-secondary" [ngClass]="{'active btn-secondary': filter == 'closed'}" (click)="switchFilter('closed')">Closed</button>
    </div>
  </div>

  <div *ngIf="creatingJob" class="alert alert-info">
    <i class="fa fa-spin fa-spinner mr-1"></i>
    Creating new Job! Please wait...
  </div>

  <div *ngIf="!gettingAllAuthenticatedUserJobs" class="animated fadeIn card card-accent-primary">
    <div class="card-header">
      <strong>Jobs</strong> list
      <div class="float-right">
        <button (click)="onNewJob()" class="btn btn-sm btn-primary">
          New job
        </button>
      </div>
    </div>

    <div *ngIf="jobs?.length === 0" class="alert alert-info mb-0">
      <i class="fa fa-info mr-1"></i>
      No jobs found.
    </div>

    <div class="table-responsive">
      <table *ngIf="jobs?.length > 0" class="table table-striped mb-0">
        <tr>
          <th>
            Project Reference
          </th>

          <th>
            <a href="javascript:" (click)="sortJobsByNumber()">
              Job Number
              <i *ngIf="jobsNumberSortingDirection === 1 && jobsSortedBy === 'number'" class="fa fa-sort-numeric-desc mr-1"></i>
              <i *ngIf="jobsNumberSortingDirection === -1 && jobsSortedBy === 'number'" class="fa fa-sort-numeric-asc mr-1"></i>
            </a>
          </th>

          <th>
            Client
          </th>

          <th>
            <a (click)="sortJobsByDate()" href="javascript:">
              Start Date
              <i *ngIf="jobsDateSortingDirection === 1 && jobsSortedBy === 'start_date'" class="fa fa-sort-numeric-desc mr-1"></i>
              <i *ngIf="jobsDateSortingDirection === -1 && jobsSortedBy === 'start_date'" class="fa fa-sort-numeric-asc mr-1"></i>
            </a>
          </th>
        </tr>

        <tr
            class="pointer"
            *ngFor="let job of jobs"
            [routerLink]="['/jobs/view/' + job.id]">
          <td>{{ job.project?.data?.title }}</td>
          <td>{{ job.number }}</td>
          <td>{{ job.client?.data?.name }}</td>
          <td>{{ job.start_date | convertDateTimeDatesFormat }}</td>
        </tr>
      </table>
    </div>

    <div *ngIf="meta && !gettingAllAuthenticatedUserJobs && meta.last_page > 1" class="card-footer">
      <app-pagination
          [meta]="meta"
          [links]="links"
          (updated)="updateJobsList($event)"></app-pagination>
    </div>
  </div>
</ion-content>
